import RecipeIngredients from './RecipeIngredients';

export default RecipeIngredients;